<!--销售订单详情页-->
<template>
  <div class="platform-order-detail">
    <Breadcrumb routeName="OrderList" toName="订单详情" goPathName="订单列表"></Breadcrumb>

    <a-spin :spinning="loading">
      <a-card :bordered="false" class="order-summary-card">
        <a-row type="flex" justify="space-between" align="top" class="summary-header">
          <a-col :span="14">
            <div class="summary-title">
              <span class="summary-icon"><a-icon type="shopping"/></span>
              <span>平台订单号：{{ orderDetail.platformOrderNo }}</span>
            </div>
          </a-col>
          <a-col :span="10" class="summary-actions">
            <a-button-group class="action-group">
              <a-button v-if="showConfirmOrderButtons">拒绝</a-button>
              <a-button>备注</a-button>
              <a-button>...</a-button>
            </a-button-group>
            <a-button v-if="showConfirmOrderButtons" type="primary">确认订单</a-button>
          </a-col>
        </a-row>

        <a-row :gutter="24" class="summary-content">
          <a-col :span="7">
            <div class="summary-line"><span>创建时间：</span>{{ orderDetail.createTime }}</div>
            <div class="summary-line"><span>支付时间：</span>{{ orderDetail.payTime || '---' }}</div>
            <div class="summary-line"><span>支付方式：</span>{{ orderDetail.payMethod || '---' }}</div>
          </a-col>
          <a-col :span="10">
            <div class="summary-line"><span>商品信息：</span>{{ orderDetail.goodsInfo }}</div>
            <div class="summary-line">
              <span>关联蜗友订单号：</span>
              <a>{{ orderDetail.relatedOrderNo }}</a>
            </div>
            <div class="summary-line"><span>备注：</span>{{ orderDetail.remark || '---' }}</div>
          </a-col>
          <a-col :span="7">
            <a-row class="status-list">
              <a-col :span="12">
                <div class="status-label">状态</div>
                <div class="status-value">{{ orderDetail.orderStatusStr }}</div>
              </a-col>
              <a-col :span="12">
                <div class="status-label">订单金额</div>
                <div class="amount-value">{{ formatMoney(orderDetail.orderAmount) }}</div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>

      <a-card :bordered="false" title="订单信息" class="detail-card">
        <detail-list :col="3" size="small">
          <detail-list-item term="联系人姓名">{{ orderBasic.orderContact }}</detail-list-item>
          <detail-list-item term="联系电话">{{ orderBasic.orderMobile }}</detail-list-item>
        </detail-list>

        <div class="block-title">商品信息</div>
        <detail-list :col="3" size="small">
          <detail-list-item term="商品标题">{{ orderBasic.orderProName }}</detail-list-item>
          <detail-list-item term="套餐/票型/价格计划名称">{{ orderBasic.orderOptionName }}</detail-list-item>
          <detail-list-item term="商品类目">{{ orderBasic.orderProTypeStr }}</detail-list-item>
          <detail-list-item term="入住日期">{{ orderBasic.orderCheckInDate }}</detail-list-item>
          <detail-list-item term="离店日期">{{ orderBasic.orderDepartureDate }}</detail-list-item>
        </detail-list>

        <div class="block-title">订单价格</div>
        <div class="order-price-row">
          <div class="order-price-item">
            <span class="price-label">单价：</span>
            <span class="price-value">{{ orderBasic.priceDetail }}</span>
          </div>
          <div class="order-price-item">
            <span class="price-label">数量：</span>
            <span class="price-value">{{ orderBasic.orderPayNum }}</span>
          </div>
          <div class="order-price-item">
            <span class="price-label">订单金额：</span>
            <span class="price-value">{{ formatMoney(orderDetail.orderAmount) }}</span>
          </div>
        </div>
      </a-card>

      <a-card :bordered="false" title="供应商备注" class="detail-card remark-card">
        <a-table
          :columns="remarkColumns"
          :dataSource="distributorRemarkList"
          rowKey="id"
          :pagination="false"
        ></a-table>
      </a-card>
    </a-spin>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'OrderDetails',
  components: {
    Breadcrumb
  },
  data() {
    return {
      loading: false,
      platformOrderNo: this.$route.query.platformOrderNo,
      orderDetail: {
        remarkList: []
      },
      orderBasic: {},
      orderPersonnel: [],
      distributorRemarkList: [],
      remarkColumns: [
        { title: '操作人', dataIndex: 'operator', width: 140 },
        { title: '备注内容', dataIndex: 'remarkContent' },
        { title: '操作时间', dataIndex: 'operateTime', width: 220 }
      ]
    }
  },
  computed: {
    showConfirmOrderButtons() {
      const flag = this.getActionFlag('confirmOrRefuseOrderFlag')
      if (flag !== undefined) return flag
      return this.isOrderStatus([2], ['待确认', '未确认'])
    },
    showRefundButton() {
      const flag = this.getActionFlag('masterOrderRefundFlag')
      if (flag !== undefined) return flag
      return this.isOrderStatus([5, 7])
    },
    showShipButton() {
      const flag = this.getActionFlag('orderShipFlag')
      if (flag !== undefined) return flag
      return this.isOrderStatus([8])
    }
  },
  watch: {
    '$route.query.platformOrderNo': {
      immediate: true,
      handler(platformOrderNo) {
        if (!platformOrderNo) return
        this.platformOrderNo = platformOrderNo
        this.getOrderDetail()
      }
    }
  },
  // mounted() {
  //   this.getOrderDetail()
  // },
  methods: {
    getActionFlag(key) {
      const sourceList = [this.orderDetail, this.orderBasic]
      for (let i = 0; i < sourceList.length; i++) {
        const source = sourceList[i]
        if (!source) continue

        const value = source[key]
        if (value === undefined || value === null || value === '') continue
        if (value === false || value === 0 || value === '0' || value === 'false') return false
        return true
      }
      return undefined
    },
    getOrderStatus() {
      const statusList = [
        this.orderDetail.orderStatus,
        this.orderDetail.status,
        this.orderBasic.orderStatus,
        this.orderBasic.orderState
      ]

      for (let i = 0; i < statusList.length; i++) {
        if (statusList[i] === undefined || statusList[i] === null || statusList[i] === '') continue

        const status = Number(statusList[i])
        if (!isNaN(status)) return status
      }
      return undefined
    },
    isOrderStatus(statusList, statusTextList = []) {
      const status = this.getOrderStatus()
      if (statusList.indexOf(status) > -1) return true

      const statusText = this.orderDetail.orderStatusStr || this.orderBasic.orderStatusStr || this.orderBasic.orderStateStr
      if (statusText === undefined || statusText === null) return false
      return statusTextList.indexOf(String(statusText).trim()) > -1
    },
    getOrderDetail() {
      this.loading = true
      this.getHttpServices().getOrderService().post('/platform/v3/orderManage/orderDetail', {
        platformOrderNo: this.platformOrderNo
      }).then(res => {
        this.orderDetail = res
        this.orderBasic = this.orderDetail.orderBasic
        this.orderPersonnel = this.orderDetail.orderPersonnel
        this.distributorRemarkList = this.orderDetail.distributorRemarkList

      }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.loading = false)
    },
    display(value) {
      return value === undefined || value === null || value === '' ? '--' : value
    },
    formatMoney(value) {
      if (value === undefined || value === null || value === '') return '--'
      return '￥ ' + Number(value).toFixed(2)
    }
  }
}
</script>

<style scoped lang="less">
.platform-order-detail {
  .order-summary-card,
  .detail-card {
    margin-bottom: 16px;
  }

  /deep/ .order-summary-card .ant-card-body {
    padding: 20px 32px 24px;
  }

  .summary-title {
    display: flex;
    align-items: center;
    height: 32px;
    font-size: 20px;
    font-weight: 600;
    color: #222;
  }

  .summary-icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    line-height: 24px;
    text-align: center;
    color: #fff;
    background: #1890ff;
    border-radius: 50%;
  }

  .summary-header {
    align-items: flex-start;
  }

  .summary-actions {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex-wrap: wrap;

    .ant-btn {
      margin-left: 8px;
      margin-bottom: 8px;
    }

    .action-group {
      margin-left: 8px;
      margin-bottom: 8px;

      .ant-btn {
        margin-left: 0;
        margin-bottom: 0;
      }
    }
  }

  .summary-content {
    margin-top: 18px;
  }

  .summary-line {
    min-height: 28px;
    line-height: 28px;
    color: rgba(0, 0, 0, .65);

    span {
      color: rgba(0, 0, 0, .85);
    }
  }

  .status-list {
    text-align: right;
  }

  .status-label {
    line-height: 22px;
    color: rgba(0, 0, 0, .45);
  }

  .status-value,
  .amount-value {
    margin-top: 4px;
    font-size: 20px;
    line-height: 28px;
    color: rgba(0, 0, 0, .85);
  }

  .block-title {
    margin: 18px 0 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, .85);
  }

  .order-price-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 32px;
    line-height: 32px;
    color: rgba(0, 0, 0, .85);
  }

  .order-price-item {
    min-width: 0;
    white-space: nowrap;
  }

  .price-label {
    margin-right: 8px;
    font-weight: 500;
  }

  .price-value {
    color: rgba(0, 0, 0, .75);
  }

  /deep/ .remark-card .ant-table-thead > tr > th {
    font-weight: 600;
    background: #fafafa;
  }
}
</style>
